var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wscn-http404-container"},[_c('div',{staticClass:"wscn-http404"},[_c('div',{staticClass:"pic-404"},[_c('i',{staticClass:"iconfont iconmaintain"})]),_vm._v(" "),_c('div',{staticClass:"bullshit"},[_c('div',{staticClass:"bullshit__oops"},[_vm._v("网站维护中!")]),_vm._v(" "),_c('div',{staticClass:"bullshit__info"},[_vm._v("网站正在维护中，请稍后访问.")]),_vm._v(" "),_c('div',{staticClass:"bullshit__info"},[_vm._v("All rights reserved\n          "),_c('a',{staticStyle:{"color":"#20a0ff"},attrs:{"href":"https://acmcoder.com","target":"_blank"}},[_vm._v("acmcoder")])])])])])
}]

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/system/index.vue?vue&type=template&id=df4e3610&scoped=true
// module id = null
// module chunks = 